import { WorldPosition } from './KVApi'

export type KVBoundingBoxJSON = {
  center: WorldPosition
  corners: Array<WorldPosition>
  max_z: number
}

export class KVBoundingBox {
  center: WorldPosition
  maxZ: number
  corners: Array<WorldPosition>

  // Y coordinates flip in unreal
  constructor(center: WorldPosition, corners: Array<WorldPosition>, z: number) {
    this.center = { ...center, y: -center.y, z: z }
    corners.sort((a, b) => b.z - a.z)

    // Just slicing doesn't deep copy
    this.corners = corners.slice(0, 4).map((c) => ({ ...c }))
    this.corners.forEach((corner, i) => {
      this.corners[i].z = z
      this.corners[i].y = -corner.y
    })

    // Sorted so that points are placed in order from bottom left to top right
    const sortCorners = () => {
      this.corners.sort((a, b) => a.y - b.y)

      if (this.corners[0].x > this.corners[1].x) {
        const temp = this.corners[0]
        this.corners[0] = this.corners[1]
        this.corners[1] = temp
      }

      if (this.corners[2].x > this.corners[3].x) {
        const temp = this.corners[2]
        this.corners[2] = this.corners[3]
        this.corners[3] = temp
      }
    }

    sortCorners()

    const getWidth = (p1: WorldPosition, p2: WorldPosition) => p2.x - p1.x
    const getHeight = (p1: WorldPosition, p2: WorldPosition) => p2.y - p1.y
    const getLength = (p1: WorldPosition, p2: WorldPosition): number => {
      const dx = getWidth(p2, p1)
      const dy = getHeight(p2, p1)
      return Math.hypot(dx, dy)
    }

    const points = []

    if (
      getLength(this.corners[0], this.corners[1]) >
      getLength(this.corners[2], this.corners[3])
    ) {
      points.push(this.corners[0], this.corners[1])
    } else {
      points.push(this.corners[2], this.corners[3])
    }

    if (
      getWidth(this.corners[0], this.corners[2]) >
      getWidth(this.corners[1], this.corners[3])
    ) {
      if (points.includes(this.corners[0])) {
        points.push(this.corners[2])
        const temp = points[0]
        points[0] = points[1]
        points[1] = temp
      } else {
        points.push(this.corners[0])
        const temp = points[0]
        points[0] = points[1]
        points[1] = temp
      }
    } else {
      if (points.includes(this.corners[1])) {
        points.push(this.corners[3])
      } else {
        points.push(this.corners[1])
      }
    }

    points.push({
      x: points[0].x + points[2].x - points[1].x,
      y: points[0].y + points[2].y - points[1].y,
      z: points[0].z,
    })

    this.corners = points
    sortCorners()
    this.maxZ = z
  }

  static fromJSON(json: KVBoundingBoxJSON): KVBoundingBox {
    return new KVBoundingBox(json.center, json.corners, json.max_z)
  }
}
